import {styled} from '@mui/material/styles';
import {Grid, TextField} from "@mui/material";
import PhoneInput from "react-phone-number-input/input";

export const RowGap10 = styled(Grid)(() => ({
  '& > *:not(:last-child)': {
    marginBottom: '0.71rem',
  },
}));

const AppInputStyles = () => ({
  marginBottom: '0.6rem',
  '& input': {
    width: '100%'
  },
  '& label': {
    fontSize: '1em',
    fontWeight: 400,
    fontFamily: 'Inter',
    letterSpacing: '.05em',
    color: 'rgba(0, 0, 0, 0.38)',
    lineHeight: 'normal',
  }
})

export const AppInput = styled(TextField)(AppInputStyles);
export const AppPhoneInput = styled(PhoneInput)(AppInputStyles);
